var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL1_wght400_GRAD0_opsz48",
    d: "M22.95,24.881l-9.655,9.655a1.366,1.366,0,1,1-1.931-1.931l9.655-9.655-9.655-9.655a1.366,1.366,0,1,1,1.931-1.931l9.655,9.655,9.655-9.655a1.366,1.366,0,1,1,1.931,1.931L24.881,22.95l9.655,9.655a1.366,1.366,0,1,1-1.931,1.931Z",
    transform: "translate(-10.95 -10.95)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconSvg);
export default __webpack_public_path__ + "static/media/closeIconSvg.3094404d88d1e8d1e0a046261d0f1edb.svg";
export { ForwardRef as ReactComponent };